import { useEffect, useState } from "react";
import Card from "./components/card";
import CardList, { CardListItem } from "./components/card-list";
import ApiList from "services/apiList";
import axios from "axios";

const Food = () => {
  const [foods, setFoods] = useState([]); // Zuwhun 1 huudas deer ashiglah state uchir redux holboh shaardlagagui
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchFoods = async () => {
      setLoading(true);
      try {
        const { data: response } = await axios.get(ApiList.getFoodListUrl);
        setFoods(response?.result);
      } catch (error) {
        alert("Сервертэй холбогдож чадсангүй");
      } finally {
        setLoading(false);
      }
    };

    fetchFoods();
  }, []);

  return (
    <Card title="Технологи карт">
      {loading ? (
        <div>Loading...</div>
      ) : (
        <>
          {foods.map((food) => (
            <CardList key={food.id} title={food.name}>
              {food.type_foods.map((item) => (
                <CardListItem key={item.code} food={item} />
              ))}
            </CardList>
          ))}
        </>
      )}
    </Card>
  );
};

export default Food;
